export default __webpack_public_path__ + "static/VehicleListWithAdds-2cf25a0221d3f0ce92f72f3e314e780a.jpg";